import axios from "axios";
import type { SiteAddressOut } from "@/shared/endpoints/inout/SiteAddressOut.ts";

export async function getSiteAddress(
  domainId: string,
  siteId: string,
): Promise<SiteAddressOut> {
  const { data } = await axios.get<SiteAddressOut>(
    `/api/domains/${domainId}/sites/${siteId}/address`,
  );
  return data;
}
